export interface DeliveryServices {
  delivery_services: DeliveryService[];
}

interface DeliveryService {
  delivery_service_id: number;
  delivery_service_name: DeliveryServiceName;
}

export type DeliveryServiceName =
  | 'Uber Eats'
  | 'DiDi Food'
  | 'anyCarry'
  | 'foodpanda'
  | 'Hotto Motto'
  | 'Rakuten Takeout'
  | 'menu'
  | 'Wolt'
  | 'Demaecan'
  | 'DoorDash'
  | 'CamelOrder'
  | 'Repitte Takeout&delivery'
  | 'CommerceMedia'
  | 'O:der ToGo'
  | 'どこでも注文くん'
  | 'RocketNow'
  | 'CamelCall'
  | 'CamelAICall';

export const deliveryServiceIdMap: Record<DeliveryServiceName, number> = {
  'Uber Eats': 1,
  'DiDi Food': 2,
  anyCarry: 3,
  foodpanda: 4,
  'Hotto Motto': 5,
  'Rakuten Takeout': 6,
  menu: 7,
  Wolt: 9,
  Demaecan: 10,
  DoorDash: 12,
  CamelOrder: 13,
  'Repitte Takeout&delivery': 14,
  CommerceMedia: 15,
  'O:der ToGo': 16,
  どこでも注文くん: 17,
  RocketNow: 24,
  CamelCall: 25,
  CamelAICall: 28,
} as const;

export type DeliveryServiceMapName =
  | 'Uber Eats'
  | 'DiDi Food'
  | 'anyCarry'
  | 'foodpanda'
  | 'Hotto Motto'
  | 'Rakuten Takeout'
  | 'menu'
  | 'Wolt'
  | '出前館'
  | 'DoorDash'
  | 'CamelOrder'
  | 'Repitte Takeout&delivery'
  | 'CommerceMedia'
  | 'O:der ToGo'
  | 'どこでも注文くん'
  | 'RocketNow'
  | 'CamelCall'
  | 'CamelAICall';

export const deliveryServiceNameMap = {
  'Uber Eats': 'Uber Eats',
  'DiDi Food': 'DiDi Food',
  anyCarry: 'anyCarry',
  foodpanda: 'foodpanda',
  'Hotto Motto': 'Hotto Motto',
  'Rakuten Takeout': 'Rakuten Takeout',
  menu: 'menu',
  Wolt: 'Wolt',
  Demaecan: '出前館',
  DoorDash: 'DoorDash',
  CamelOrder: 'CamelOrder',
  'Repitte Takeout&delivery': 'Repitte Takeout&delivery',
  CommerceMedia: 'CommerceMedia',
  'O:der ToGo': 'O:der ToGo',
  どこでも注文くん: 'どこでも注文くん',
  RocketNow: 'RocketNow',
  CamelCall: 'CamelCall',
  CamelAICall: 'CamelAICall',
} as const;
